import { CommandHandlerProvider } from '@/Application/CommandHandlerProvider'
import { TrackingRepository } from '@/Domain/Tracking/TrackingRepository'
import { InMemoryTrackingRepository } from '../InMemoryTrackingRepository'
import { FetchTrackingCommandHandler } from '@/Application/Tracking/FetchTrackingCommandHandler'
import { AxiosTrackingRepository } from '../AxiosTrackingRepository'
import { AxiosApiClient } from '@/Infrastructure/ApiClient'
import { SessionTokenStorage } from '@/Infrastructure/Account/SessionTokenStorage'
import { AxiosTrackingFactory } from '../AxiosTrackingFactory'

export class FetchTrackingCommandHandlerProvider
implements CommandHandlerProvider<FetchTrackingCommandHandler> {
  provide (): FetchTrackingCommandHandler {
    const handler = new FetchTrackingCommandHandler(
      this.get()
    )
    return handler
  }

  private get (): TrackingRepository {
    if (process.env.VUE_APP_API_ENV === 'local') {
      return new InMemoryTrackingRepository()
    }
    return new AxiosTrackingRepository(
      new AxiosApiClient(new SessionTokenStorage()),
      new AxiosTrackingFactory()
    )
  }
}
